module.exports = __webpack_public_path__ + "static/img/luyinweisha_icon.d23095d.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/shop_img_icon/luyinweisha_icon.png
// module id = 9cpI
// module chunks = 1